import { createAsyncAction } from 'redux-promise-middleware-actions';
import dayjs from 'dayjs';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { tneAxiosClient } from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_TIMESHEETS: 'GET_TIMESHEETS',
    GET_NEXT_TIMESHEETS: 'GET_NEXT_TIMESHEETS',
    DELETE_TIMESHEET: 'DELETE_TIMESHEET'
  })
};

const handleAbort = (abortRef) => {
  if (!abortRef) {
    return new AbortController();
  }
  if (abortRef.current) {
    abortRef.current.abort();
  }
  abortRef.current = new AbortController();
  return abortRef.current;
};

const commonGetTimesheetsRequest = (
  id,
  pageNumber,
  pageSize,
  start,
  month,
  year,
  location,
  status,
  contractor,
  sortby,
  t,
  isApprover,
  filtersOptions,
  abortRef
) => {
  const controller = handleAbort(abortRef);

  if (isApprover) {
    const endpoint = 'v1/get-timesheets-by-approverId';

    const requestBody = {
      userId: id,
      PageNumber: pageNumber,
      PageSize: pageSize,
      SortBy: Array.isArray(sortby) ? sortby[0] : sortby
    };

    if (start) {
      requestBody.StartDate = start;
      requestBody.EndDate = dayjs(start).add(6, 'day').format('DD-MMM-YYYY');
    }

    if (location && location !== t('common.general.all')) {
      requestBody.Location = location;
    }

    if (status && status !== t('common.general.all')) {
      requestBody.Status = status;
    }

    if (contractor?.FirstName && contractor?.LastName && contractor !== t('common.general.all')) {
      requestBody.Contractors = {
        FirstName: contractor.FirstName,
        LastName: contractor.LastName
      };
    }

    if (month && month !== t('common.general.all')) {
      requestBody.Month = month;
    }

    if (year && year !== t('common.general.all')) {
      requestBody.Year = year;
    }

    if (month && !year && filtersOptions?.Years?.length) {
      requestBody.Year = filtersOptions.Years.at(-1).Year;
    }

    return tneAxiosClient.post(endpoint, requestBody, { signal: controller.signal }).then((res) => res?.data);
  }
  let basicUrl =
    `v1/timesheet/dashboard?userId=${id}` +
    `&PageNumber=${pageNumber}` +
    `&PageSize=${pageSize}` +
    `&StartDate=${start}` +
    `&SortBy=${sortby}` +
    `&EndDate=${start ? dayjs(start).add(6, 'day').format('DD-MMM-YYYY') : ''}`;

  if (location && location !== t('common.general.all')) basicUrl += `&Location=${location}`;
  if (status && status !== t('common.general.all')) basicUrl += `&Status=${status}`;
  if (contractor?.FirstName && contractor?.LastName && contractor !== t('common.general.all'))
    basicUrl += `&FirstName=${contractor.FirstName}&LastName=${contractor.LastName}`;
  if (month && month !== t('common.general.all')) basicUrl += `&Month=${month}`;
  if (year && year !== t('common.general.all')) basicUrl += `&Year=${year}`;
  if (month && !year && filtersOptions?.Years?.length) basicUrl += `&Year=${filtersOptions.Years.at(-1).Year}`;

  return tneAxiosClient.get(basicUrl, { signal: controller.signal }).then((res) => res?.data);
};

export const getTimesheets = createAsyncAction(types.GET_TIMESHEETS, commonGetTimesheetsRequest);

export const getNextTimesheets = createAsyncAction(types.GET_NEXT_TIMESHEETS, commonGetTimesheetsRequest);

export const deleteTimesheet = createAsyncAction(types.DELETE_TIMESHEET, (id) => {
  return tneAxiosClient.delete(`v1/timesheet?timesheetId=${id}`).then(() => id);
});
